import Navbar from "./Navbar";
import Footer from "./Footer";
import { AccessibilityWidget } from "@/components/accessibility/AccessibilityWidget";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col bg-slate-50 font-sans text-slate-900" dir="rtl">
      <Navbar />
      {/* Adding pt-20 (80px) to ensure content starts after the 64px fixed navbar */}
      <main className="flex-1 container mx-auto px-4 pt-20 pb-8">
        {children}
      </main>
      <Footer />
      <AccessibilityWidget />
    </div>
  );
};

export default Layout;